import { useQuery } from "@tanstack/react-query";
import { getCoreAxiosInstance } from "../../api/CoreAxiosInstance";
import { RunDetailSchema } from "../types";

export function useShadowRunDetail(runId: string) {
  return useQuery({
    queryKey: ["shadowRunDetail", runId],
    queryFn: async () => {
      const instance = await getCoreAxiosInstance();
      const { data } = await instance.get(`/api/v1/shadow/batches/${runId}`);
      return RunDetailSchema.parse(data);
    },
    enabled: !!runId,
  });
}
